module.exports = __webpack_public_path__ + "static/media/elf.c6d5c344.svg";